import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { HandleError, HttpErrorHandlerService } from '../http-error-handler.service';
import { Appointment } from 'src/app/model/Security/Appointment';
import { ToastService } from 'src/app/service/toast.service';
import { environment } from 'src/environments/environment';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {
  private handleError: HandleError;
  constructor(private toastService: ToastService,
    private apiFactory: APIFactoryEndPoints,
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService
  ) {
    this.handleError = httpErrorHandler.createHandleError('AppointmentAPIService');
  }
  createAppointment(appointment: Appointment): Observable<any> {
    Object.getOwnPropertyNames(appointment).forEach(key => {
    });
   
    return this.http.post(this.apiFactory.serverNewUrl,
      appointment,
      { responseType: 'json' })
      .pipe(
        catchError(this.handleError('createAppointment()', appointment))
      );
  }
  editAppointment(editAppointment: Appointment): Observable<any> {
    Object.getOwnPropertyNames(editAppointment).forEach(key => {
    });
      return this.http.post(this.apiFactory.serverNewUrl,
        editAppointment,
        { responseType: 'json' })
        .pipe(
          catchError(this.handleError('editAppointment()', editAppointment))
        );
  }
}
